import styled from "styled-components";

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: ${({ theme }) => theme.padding.small};
  margin: 0;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadow.large};
  width: 100%;
`;

export const StyledIconContainer = styled.div`
  display: flex;
  justify-content: end;
`;
